import { copy } from "shared/assets";
import { IFieldType, IFormButtons, IFormField } from "shared/types";

export const fields: IFormField[] = [
  {
    name: "email",
    label: copy.authFormFields.email,
    type: IFieldType.email,
    note: copy.venueEditors.invite.note,
    validation: {
      required: copy.errors.required,
    },
  },
];

export const getButtons = (handleCancel: () => void): IFormButtons => ({
  primary: {
    children: copy.venueEditors.button,
    "data-testid": "invite_editors_submit",
  },
  secondary: {
    onClick: handleCancel,
  },
});
